module.exports = __webpack_public_path__ + "static/media/marker_map_marker.274c2eff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_map_marker.svg
// module id = 239
// module chunks = 0